import React, { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { updateDoc, doc } from "firebase/firestore";
import { getDb } from "../../util/Constants";
import { Spinner } from "reactstrap";

export default function DraggableImages({ 
  // row, showCross, handleRemoveOptionImage 
  row,
  showCross,
  handleRemoveOptionImage,
  editedOptions,
  setEditedOptions,
}) {
  const images = editedOptions;
  const [loading, setLoading] = useState(false);

  const handleRemoveImage = (indexToRemove) => {
    const updatedImages = images.filter((_, index) => index !== indexToRemove);
    setEditedOptions(updatedImages);
    // handleRemoveOptionImage(indexToRemove)
  };


  const onDragEnd = (result) => {
    if (!result.destination) return;
    const reordered = Array.from(images);
    const [removed] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, removed);
    setEditedOptions(reordered);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId={`droppable-${row.id}`} direction="horizontal">
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className="draggable-container"
          >
            {images.map((img, idx) => (
              <Draggable
                key={`${img}-${idx}`} draggableId={`${img}-${idx}`} index={idx}
              // key={img} draggableId={img} index={idx}
              >
                {(provided2) => (
                  <div
                    ref={provided2.innerRef}
                    {...provided2.draggableProps}
                    {...provided2.dragHandleProps}
                    style={{
                      userSelect: "none",
                      position: "relative",
                      margin: "0 2px",
                      ...provided2.draggableProps.style,
                    }}
                  >
                    <img
                      src={img}
                      alt=""
                      width={60}
                      height={60}
                      className="draggable-image"
                    />
                    {showCross &&
                      <button
                        onClick={() => handleRemoveImage(idx)}
                        style={{
                          position: "absolute",
                          top: "2px",
                          right: "2px",
                          color: "#dc3545",
                          fontSize: "16px",
                          fontWeight: "bold",
                          cursor: "pointer",
                          background: "#fff",
                          borderRadius: "50%",
                          padding: "0 4px",
                          lineHeight: "16px",
                          border: "none",
                        }}
                      >
                        &times;
                      </button>
                    }

                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
            {loading && <Spinner size="sm" color="primary" />}
          </div>
        )}
      </Droppable>
    </DragDropContext >
  );
}

